const resultFunction = (favoriteAssets, getAsset) => (assetName) => {
  const asset = getAsset(assetName)

  return asset && asset.isCombined
    ? asset.combinedAssetNames.some((name) => Boolean(favoriteAssets[name]))
    : Boolean(favoriteAssets[assetName])
}

const getIsFavoriteSelectorDefinition = {
  id: 'getIsFavorite',
  resultFunction,
  dependencies: [
    //
    { selector: 'data' },
    { selector: 'getAsset', module: 'assets' },
  ],
}

export default getIsFavoriteSelectorDefinition
